import HeaderWidget from "../../../../common/components/molecule/HeaderWidget/HeaderWidget";
import { useMicroNavigator } from "../../../../common/components/organisme/MicroNavigator/MicroNavigatorContext";
import SinglePole from "../../../../features/planBT/components/Pole/SinglePole";
import styles from './SinglePolePage.module.scss'

export default function SinglePolePage() {
  const {navigate} =useMicroNavigator()
  return (
  
    <div  className={styles['page']}style={{color: 'white'}}>
       <HeaderWidget  withBackBtn handleBackBtn={() => navigate('list')} variant="dark"><SinglePole.Name/></HeaderWidget>
        
        <SinglePole.PoleNumber/>
        <div className={styles["page__location-container"]}>
        <SinglePole.Location/>
        </div>
    </div>
  )
}
